/**
 * @fileoverview Estilos dos feriados: a lista, o diálogo de criar/editar e o de
 * importar os feriados nacionais.
 */

import { makeStyles } from "@material-ui/core/styles";

import { modernFieldStyles } from "../ModernSelect";
import { tokens } from "../Triage/styles";

const useExceptionStyles = makeStyles((theme) => {
  const c = tokens(theme.palette.type === "dark");
  const xs = theme.breakpoints.down("xs");
  const button = { height: 36, borderRadius: 10, textTransform: "none", fontWeight: 600, boxShadow: "none" };
  return {
    toolbar: { display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 8, marginBottom: 10 },
    primaryButton: { ...button, "&:hover": { boxShadow: "none" } },
    ghostButton: { ...button, fontWeight: 500, color: c.textSecondary, borderColor: c.inputBorder },
    list: { background: c.surface, border: `1px solid ${c.border}`, borderRadius: 12, overflow: "hidden" },
    row: {
      display: "grid",
      gridTemplateColumns: "120px minmax(0, 1fr) 140px 76px",
      alignItems: "center",
      gap: 16,
      padding: "12px 16px",
      borderBottom: `1px solid ${c.border}`,
      "&:last-child": { borderBottom: "none" },
      // No celular, cada dado numa linha (a observação longa não espreme a data).
      [xs]: { gridTemplateColumns: "minmax(0, 1fr)", gap: 6 },
    },
    head: {
      background: c.subtle,
      fontSize: 11,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.06em",
      color: c.textMuted,
      [xs]: { display: "none" },
    },
    date: { fontSize: 14, fontWeight: 600, color: c.textPrimary },
    note: { fontSize: 13, color: c.textSecondary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    status: {
      justifySelf: "start",
      padding: "2px 10px",
      borderRadius: 999,
      fontSize: 12,
      fontWeight: 600,
      background: c.hover,
      color: c.textPrimary,
      whiteSpace: "nowrap",
    },
    statusClosed: { color: c.textSecondary },
    actions: { display: "flex", justifyContent: "flex-end", gap: 2 },
    iconButton: { color: c.textMuted, "&:hover": { color: c.textPrimary, background: c.hover } },
    deleteButton: { "&:hover": { color: c.danger } },
    empty: { padding: 24, textAlign: "center", fontSize: 13, color: c.textMuted },

    paper: { width: "100%", maxWidth: 480, borderRadius: 16, background: c.surface, border: `1px solid ${c.border}` },
    dialogHeader: { display: "flex", alignItems: "flex-start", gap: 12, padding: "20px 24px 0" },
    dialogTitle: { margin: 0, fontSize: 17, fontWeight: 600, color: c.textPrimary },
    dialogDescription: { margin: "4px 0 0", fontSize: 13, color: c.textSecondary, lineHeight: 1.5 },
    closeButton: { marginLeft: "auto", marginTop: -4, color: c.textMuted },
    dialogBody: { display: "flex", flexDirection: "column", gap: 16, padding: "20px 24px" },
    label: { display: "block", marginBottom: 6, fontSize: "0.8rem", fontWeight: 600, color: c.textPrimary },
    field: { ...modernFieldStyles(theme), width: "100%" },
    switchRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      padding: "10px 14px",
      borderRadius: 12,
      border: `1px solid ${c.border}`,
      background: c.subtle,
    },
    switchTitle: { display: "block", fontSize: 14, fontWeight: 600, color: c.textPrimary },
    switchHint: { display: "block", fontSize: 12.5, color: c.textSecondary },
    timeRow: { display: "flex", alignItems: "center", gap: 10 },
    timeDash: { color: c.textMuted },
    error: { margin: 0, fontSize: 12.5, color: c.danger },
    dialogActions: { display: "flex", justifyContent: "flex-end", gap: 8, padding: "0 24px 20px" },
    holidayList: { display: "flex", flexDirection: "column", maxHeight: 360, overflowY: "auto", margin: "0 -8px" },
    holidayRow: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "2px 8px",
      borderRadius: 8,
      cursor: "pointer",
      "&:hover": { background: c.hover },
    },
    holidayRowDisabled: { cursor: "default", "&:hover": { background: "transparent" } },
    holidayDate: { width: 92, flexShrink: 0, fontSize: 13, fontWeight: 600, color: c.textPrimary },
    holidayName: { flex: 1, minWidth: 0, fontSize: 13, color: c.textPrimary },
    holidayTag: { fontSize: 12, color: c.textMuted, whiteSpace: "nowrap" },
  };
});

export default useExceptionStyles;
